import { UserDeviceEnum } from "@/__generated__/graphql";

import { toast } from "@luce/ui";

import { collectError } from "../monitoring/sentry";

export const handleWhatsappNumber = (number: string, template = "") => {
  const phone = number.replace(/\D/g, "");
  handleOpenLink("//wa.me/" + phone + "?text=" + template);
};

export const getUserDevice = () => {
  return UserDeviceEnum.Browser;
};
export const getAnalyticDevice = () => {
  return "web";
};
export function makeFileFromPicker(fileInfo: File, customFilename?: string) {
  const fileName = fileInfo.name.replace(/\.[^/.]+$/, "");
  const type = fileInfo.type.split("/");
  const format = type[1];

  const file = new File(
    [fileInfo],
    customFilename ? `${customFilename}.${format}` : `${fileName}.${format}`,
    { type: fileInfo.type },
  );

  return file;
}

export const handleOpenLink = async (url: string) => {
  window.open(url, "_blank");
  return Promise.resolve(true);
};

export const shareLocalFile = (fileUri: string) => {
  window.open(fileUri, "_blank");
  return Promise.resolve();
};

export const share = (url: string, message = url) => {
  if (!navigator.canShare) {
    toast.error("Your browser doesn't support the Web Share API.");
    return;
  }

  navigator.share({ url, text: message }).catch((error) => {
    if (error instanceof Error) {
      const errString = error.toString();
      if (errString.includes("AbortError") || errString.includes("InvalidStateError")) {
        // ignore when user cancel share
        return;
      } else if (errString.includes("NotAllowedError")) {
        toast.error(
          "Sharing failed due to blocked permissions, inactive window, or security restrictions. Please check your settings and try again",
        );
      }
    }

    collectError(error, {
      tags: {
        feature: "web_share",
      },
    });
  });
};

export const downloadFromUrl = async (url: string, fileName: string) => {
  // TODO: handle download from url correctly
  try {
    // Fetch the file as a blob to ensure download works for images and cross-origin URLs
    const response = await fetch(url, { mode: "cors" });
    if (!response.ok) throw new Error("Network response was not ok");
    const blob = await response.blob();
    const blobUrl = window.URL.createObjectURL(blob);

    const downloadLink = document.createElement("a");
    downloadLink.href = blobUrl;
    downloadLink.download = fileName;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);

    // Clean up the blob URL after download
    setTimeout(() => window.URL.revokeObjectURL(blobUrl), 100);

    return Promise.resolve();
  } catch (error) {
    console.error("Error downloading file:", error);
  }
};

export const downloadAndShare = async (downloadUri: string, fileName: string = "image.jpg") => {
  if (!navigator.share) {
    toast.error("Your browser doesn't support the Web Share API.");
    return Promise.resolve(false);
  }

  return navigator
    .share({
      url: downloadUri,
      text: `Download ${fileName}`,
    })
    .then(() => {
      return true;
    })
    .catch((error) => {
      if (error instanceof Error) {
        const errString = error.toString();
        if (errString.includes("AbortError") || errString.includes("InvalidStateError")) {
          // ignore when user cancel share
        } else if (errString.includes("NotAllowedError")) {
          toast.error(
            "Sharing failed due to blocked permissions, inactive window, or security restrictions. Please check your settings and try again",
          );
        }
        return false;
      }

      collectError(error, {
        tags: {
          feature: "web_share",
        },
      });
      return false;
    });
  return true;
};
